import { SellRequest } from 'model'
import { useMemo } from 'react'
import {
  ProductPhotos,
  MorePhotosCard,
  ProductPhoto,
  FirebaseImage,
  SectionHeader,
} from 'core/components'
import { Image } from 'ui/core'
import PhotosAction from './PhotosAction'

export interface SellRequestProductPhotosProps {
  sellRequest?: SellRequest,
}

const SellRequestProductPhotos = ({ sellRequest }: SellRequestProductPhotosProps) => {
  const sortedPhotos = useMemo(
    () =>
      sellRequest?.images?.slice().sort((a, b) => {
        if (a.isReceipt)
          return -1
        if (b.isReceipt)
          return 1
        return 0
      }) || [],
    [sellRequest?.images],
  )

  const isAcceptedOrSubmitted
    = sellRequest?.status?.name === 'ACCEPTED' || sellRequest?.status?.name === 'SUBMITTED'

  return (
    <div>
      <SectionHeader title="Photos" action={isAcceptedOrSubmitted ? <PhotosAction /> : undefined} />
      <ProductPhotos
        photos={sortedPhotos}
        renderPhoto={({ photo, height, index, onClick }) => (
          <ProductPhoto
            key={`${photo.name}-${index}`}
            label={photo.isReceipt ? 'Receipt' : photo.side}
            onClick={onClick}
          >
            <FirebaseImage
              withLoader
              height={height}
              width="100%"
              radius={0}
              path={photo.fullPath}
              renderRoot={(props) => (
                <Image
                  {...props}
                  alt={photo.name}
                  w="100%"
                  h={height}
                />
              )}
            />
          </ProductPhoto>
        )}
        renderCarouselPhoto={({ photo, height }) => (
          <FirebaseImage
            withLoader
            loaderType="oval"
            height={height}
            width="100%"
            radius={0}
            path={photo.fullPath}
            renderRoot={(props) => (
              <Image
                {...props}
                fit="contain"
                w="100%"
                h={height}
              />
            )}
          />
        )}
        renderMorePhotos={({ photos, height, expand }) => (
          <FirebaseImage
            withLoader
            height={height}
            width="100%"
            key={photos.length}
            radius={0}
            path={photos[0].fullPath}
            renderRoot={(props) => (
              <MorePhotosCard
                {...props}
                onClick={expand}
                w="100%"
                h={height}
              />
            )}
          >
            {photos.length} more
          </FirebaseImage>
        )}
      />
    </div>
  )
}

export default SellRequestProductPhotos
